import React,{useState} from 'react';
import {
    TextField,
    Button,
    Box,
    Typography,
    Checkbox,
    Link,
    Divider,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { signin } from '../api/auth';
const SignIn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const { login } = useAuth();
    const navigate = useNavigate();
  
    const handleLogin = async () => {
        setError('');
        try {
            const response = await signin({ username:email, password });
            await login(response.data.access_token)
            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid email or password');
        }
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor="#f5f5f5"
        >
            <Box
                width="400px"
                height="-webkit-fill-available"
                bgcolor="#fff"
                p={4}
                borderRadius={2}
                boxShadow="0 4px 20px rgba(0, 0, 0, 0.1)"
            >
                <Typography variant="h5" textAlign="center" fontWeight="bold" gutterBottom>
                    Welcome Back!
                </Typography>

                {error && (
                    <Typography color="error" textAlign="center" mb={2}>
                        {error}
                    </Typography>
                )}
                <TextField
                     label="Email"
                     variant="outlined"
                     fullWidth
                     margin="normal"
                     size="small"
                     value={email}
                     onChange={(e) => setEmail(e.target.value)}
                />

                <TextField
                     label="Password"
                     type="password"
                     variant="outlined"
                     fullWidth
                     margin="normal"
                     size="small"
                     value={password}
                     onChange={(e) => setPassword(e.target.value)}
                />

                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleLogin}
                    sx={{
                        mt: 2,
                        mb: 1,
                        textTransform: 'none',
                        height: '45px',
                        fontWeight: 'bold',
                    }}
                >
                    Login
                </Button>

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={1}
                    mb={2}
                >
                    <Box display="flex" alignItems="center">
                        <Checkbox size="small" />
                        <Typography variant="body2">Remember Me</Typography>
                    </Box>
                    <Link href="#" variant="body2" underline="hover">
                        Forgot Your Password?
                    </Link>
                </Box>
                <Typography variant="body2" textAlign="center" mt={2}>
                    Don't have an account?{' '}
                    <Link href="/signup" underline="hover">
                        Sign Up Here
                    </Link>
                </Typography>
                <Divider sx={{ my: 2,color:"#6876D5" }}></Divider>

               

            </Box>
        </Box>
    );
};

export default SignIn;
